const MAX_LENGTH_BEFORE_NEWLINE = 21

export const insertNewLineAfterLastSlash = (str: string): string => {
  if (str.length <= MAX_LENGTH_BEFORE_NEWLINE) {
    return str
  }

  const slashCount = str.split('/').length - 1

  if (slashCount >= 2) {
    const lastSlashIndex = str.lastIndexOf('/')

    const modifiedStr = `${str.slice(0, lastSlashIndex + 1)}\n${str.slice(
      lastSlashIndex + 1
    )}`

    return modifiedStr
  }

  return str
}
